module.exports = __webpack_public_path__ + "img/selected_star.1d59e789.svg";